const accessRegistration = {
    INVITE_STUDENT_LIST: { name: 'Invite Student', path: '/invite-student-list' },
    ADD_INVITE_STUDENT: { name: 'Add Invite Student', path: '/add-invite-student' },

    STUDENT_INSTITUTE_ENROLLMENT_LIST: { name: 'Student Institute Enrollment', path: '/student-institute-enrollment-list' },
    ADD_STUDENT_INSTITUTE_ENROLLMENT: { name: 'Add Student Institute Enrollment', path: '/add-student-institute-enrollment' },
    UPDATE_STUDENT_INSTITUTE_ENROLLMENT: { name: 'Update Student Institute Enrollment', path: '/edit-student-institute-enrollment' },
    DELETE_STUDENT_INSTITUTE_ENROLLMENT: { name: 'Delete Student Institute Enrollment', path: '/delete-student-institute-enrollment' },
}

export default accessRegistration;
